// extracted by mini-css-extract-plugin
module.exports = {"root":"FAQSectionFooter_root__1Zm-s","content":"FAQSectionFooter_content__-oXym"};